// 与 humi-android / 声音复刻工具共用：用户录音时需朗读的口播文案
export const VOICE_CLONE_READING_TEXTS = {
  zh: [
    '路过街角的咖啡店，看见窗边的人，在阳光下发呆。忽然明白，幸福从不需要刻意。可以是晴朗的天气、冰镇的汽水，或是晚风里的夏意。慢慢走路，慢慢生活。',
    '云朵是棉花糖做的，太阳出来就会慢慢化掉。路边的小猫藏着自己的工作，白天慢悠悠散步，晚上悄悄奔赴夜色。电梯关门的 “叮”声，是下一段旅程的开场白，“下一站，冒险开始。”',
    '这本书的借阅记录像是一条隐秘的线索。近三个月，七个人，频繁地借阅同一本书。我回想起那个年轻女孩，还书时书页上的折痕，像是刻意留下的标记，又像是无意的疏忽。这背后，究竟藏着怎样的秘密？',
  ],
  en: [
    'Sitting in the quiet forest, I listen to the birds singing. The sun filters through the leaves, painting gold on the ground. A soft breeze carries the smell of pine and wildflowers.',
    'Oh no! The kitchen baking went wrong! Giant, fluffy cupcakes are bouncing all over the house! We need to shrink them before Mom sees. Hurry, use your magic to make them small again.',
    'The strange symbol on the door looks familiar. I’ve seen it in old police reports. It’s the mark of a hidden gang that’s been stealing from the town. This is the clue we’ve been waiting for.',
  ],
} as const;

export type VoiceCloneReadingTextLang = keyof typeof VOICE_CLONE_READING_TEXTS;
